import HeroHomeDonneurOrdre from "../../components/HeroHomeDonneurOrdre";
import ListMainServices from "../../components/ListMainServices";

export default function EspaceDonneurDOrdres(){
    return(
        <main>
            <HeroHomeDonneurOrdre/>
            <ListMainServices />
            
        </main>
    )
} 